/* Mindil v1 storefront behaviour (US: no free-delivery bar): drawers, AJAX cart, predictive search, product form, sticky bar. */
(function () {
  'use strict';
  var M = window.MINDIL || {};
  var ROOT = M.root || '/';
  if (ROOT.slice(-1) !== '/') ROOT += '/';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };

  /* Money (Shopify money_format) */
  function money(cents) {
    cents = Math.round(Number(cents) || 0);
    var fmt = M.moneyFormat || '${{amount}}';
    function delim(n, prec, th, dec) {
      var parts = (n / 100).toFixed(prec).split('.');
      return parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + th) + (parts[1] ? dec + parts[1] : '');
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      switch (k) {
        case 'amount_no_decimals': return delim(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return delim(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return delim(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return delim(cents, 2, "'", '.');
        default: return delim(cents, 2, ',', '.');
      }
    });
  }
  function imgUrl(url, w) { if (!url) return ''; return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }

  /* Overlays */
  var openId = null, lastFocus = null;
  function openPanel(id) {
    var el = document.getElementById(id); if (!el) return;
    if (openId === id) { closePanels(); return; }
    lastFocus = document.activeElement; closePanels(true);
    openId = id; el.hidden = false; var scrim = $('.m-scrim'); if (scrim) scrim.hidden = false;
    document.body.classList.add('m-lock');
    if (id === 'm-search') { var q = $('#m-q'); if (q) setTimeout(function () { q.focus(); }, 30); }
    else { var c = el.querySelector('[data-m-close]'); if (c) c.focus(); }
    if (id === 'm-cart') refreshCart();
  }
  function closePanels(keepFocus) {
    $$('#m-cart, #m-search, #m-menu').forEach(function (el) { el.hidden = true; });
    var scrim = $('.m-scrim'); if (scrim) scrim.hidden = true;
    document.body.classList.remove('m-lock');
    openId = null;
    if (!keepFocus && lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
  }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && openId) closePanels(); });

  /* The menu panel is rendered inside the sticky header; move it next to the other overlays
     so it sits above the dimmed background instead of under it. */
  function hoistMenu() {
    var host = document.getElementById('m-overlays'); if (!host) return;
    var menus = $$('#m-menu');
    var fresh = menus.filter(function (m) { return !host.contains(m); })[0];
    if (!fresh) return;
    menus.forEach(function (m) { if (m !== fresh) m.remove(); });
    host.appendChild(fresh);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hoistMenu); else hoistMenu();

  /* Toast */
  var toastT;
  function toast(html) {
    var t = $('#m-toast'); if (!t) return;
    t.innerHTML = html; t.hidden = false;
    clearTimeout(toastT); toastT = setTimeout(function () { t.hidden = true; }, 3000);
  }

  /* Cart */
  var lastCart = null;
  function getCart() { return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function setCount(n) {
    $$('[data-m-count]').forEach(function (b) { b.textContent = n; b.hidden = !n; });
    $$('[data-m-cart-btn]').forEach(function (b) { b.setAttribute('aria-label', 'Open cart, ' + n + ' items'); });
  }
  function freeHtml(total) {
    if (!M.freeCents) return '';
    var left = M.freeCents - total, pct = Math.min(100, Math.round(total / M.freeCents * 100));
    return '<div class="m-free"><span>' + (left > 0 ? 'Add ' + money(left) + ' more for free delivery' : 'Your order gets free delivery') + '</span><div class="m-bar" aria-hidden="true"><i style="width:' + pct + '%"></i></div></div>';
  }
  function renderCart(cart) {
    lastCart = cart; setCount(cart.item_count);
    document.dispatchEvent(new CustomEvent('m:cart', { detail: cart }));
    var body = $('#m-cart-body'); if (!body) return;
    if (!cart.item_count) {
      body.innerHTML = '<p class="m-empty" style="padding:24px 0;margin:0">Your cart is empty.</p><a class="m-btn m-btn--block" href="' + ROOT + 'collections/all">Continue shopping</a>';
      return;
    }
    var lines = cart.items.map(function (it) {
      var variant = it.variant_title && it.variant_title !== 'Default Title' ? '<div class="m-line__v">' + esc(it.variant_title) + '</div>' : '';
      var img = it.image ? '<img src="' + esc(imgUrl(it.image, 160)) + '" alt="" width="64" height="64" loading="lazy">' : '<span class="m-nophoto"></span>';
      var price = it.original_line_price !== it.final_line_price ? money(it.final_line_price) + ' <s style="color:var(--m-muted)">' + money(it.original_line_price) + '</s>' : money(it.final_line_price);
      return '<div class="m-line">' + img +
        '<div style="min-width:0"><a class="m-line__t" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' + variant + '<div style="font-size:14px">' + price + '</div></div>' +
        '<div class="m-qty"><button type="button" data-m-line="' + esc(it.key) + '" data-m-to="' + (it.quantity - 1) + '" aria-label="Remove one ' + esc(it.product_title) + '">−</button><output>' + it.quantity + '</output><button type="button" data-m-line="' + esc(it.key) + '" data-m-to="' + (it.quantity + 1) + '" aria-label="Add one ' + esc(it.product_title) + '">+</button></div></div>';
    }).join('');
    var discounts = (cart.cart_level_discount_applications || []).map(function (d) { return '<div class="m-subtotal" style="font-size:14px;color:var(--m-muted)"><span>' + esc(d.title) + '</span><span>−' + money(d.total_allocated_amount) + '</span></div>'; }).join('');
    body.innerHTML = lines +
      '<div class="m-cart-foot">' + freeHtml(cart.total_price) + discounts +
      '<div class="m-subtotal"><span>Subtotal</span><span>' + money(cart.total_price) + '</span></div>' +
      '<form action="' + ROOT + 'cart" method="post"><button type="submit" name="checkout" class="m-btn m-btn--block">Check out</button></form>' +
      '<a class="m-btn m-btn--line m-btn--block" href="' + ROOT + 'cart">View cart</a>' +
      '<p class="m-note">Taxes and shipping are calculated at checkout.</p></div>';
  }
  function refreshCart() { return getCart().then(renderCart).catch(function () {}); }
  function addItems(items, btn, meta) {
    if (btn) { btn.classList.add('is-busy'); btn.setAttribute('aria-busy', 'true'); }
    return fetch(ROOT + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok) { toast('<span style="flex:1;font-size:14px">' + esc(res.d.description || res.d.message || 'Could not add this item.') + '</span>'); return; }
        var it = (res.d.items && res.d.items[0]) || res.d;
        var title = (meta && meta.title) || it.product_title || 'Item';
        var img = (meta && meta.img) || (it.image ? imgUrl(it.image, 120) : '');
        toast((img ? '<img src="' + esc(img) + '" alt="" width="44" height="44">' : '') + '<span style="flex:1;font-size:14px">Added <strong>' + esc(title) + '</strong> to cart</span><button type="button" data-m-open="m-cart">View cart</button>');
        return refreshCart();
      })
      .catch(function () { toast('<span style="flex:1;font-size:14px">Something went wrong. Please try again.</span>'); })
      .then(function () { if (btn) { btn.classList.remove('is-busy'); btn.removeAttribute('aria-busy'); } });
  }
  function changeLine(key, qty) {
    return fetch(ROOT + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: Math.max(0, qty) }) })
      .then(function (r) { return r.json(); })
      .then(function (cart) { if (cart && cart.items) renderCart(cart); else refreshCart(); });
  }

  /* Clicks */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-m-open], [data-m-close], [data-m-add], [data-m-line], [data-m-step], [data-m-sticky-add]');
    if (!t) return;
    if (t.hasAttribute('data-m-open')) { e.preventDefault(); var tt = $('#m-toast'); if (tt) tt.hidden = true; openPanel(t.getAttribute('data-m-open')); return; }
    if (t.hasAttribute('data-m-close')) { e.preventDefault(); closePanels(); return; }
    if (t.hasAttribute('data-m-add')) { e.preventDefault(); addItems([{ id: Number(t.getAttribute('data-m-add')), quantity: 1 }], t, { title: t.getAttribute('data-m-title'), img: t.getAttribute('data-m-img') }); return; }
    if (t.hasAttribute('data-m-line')) { changeLine(t.getAttribute('data-m-line'), Number(t.getAttribute('data-m-to'))); return; }
    if (t.hasAttribute('data-m-step')) {
      var input = t.parentNode.querySelector('[data-m-qty]'); if (!input) return;
      input.value = Math.max(1, Math.min(99, (parseInt(input.value, 10) || 1) + Number(t.getAttribute('data-m-step'))));
      input.dispatchEvent(new Event('change', { bubbles: true })); return;
    }
    if (t.hasAttribute('data-m-sticky-add')) { var f = $('#m-product-form'); if (f) { var sb = f.querySelector('[data-m-submit]'); if (sb && !sb.disabled) f.requestSubmit ? f.requestSubmit(sb) : sb.click(); } }
  });

  /* Header: shadow on scroll, sticky offset under the announcement */
  var header = $('[data-m-header]');
  function onScroll() { if (header) header.classList.toggle('is-scrolled', window.scrollY > 8); }
  function measure() { var a = $('.m-announce'); document.documentElement.style.setProperty('--m-ann-h', (a ? a.offsetHeight : 0) + 'px'); }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', measure);
  measure(); onScroll();

  /* Search */
  var q = $('#m-q'), results = $('#m-search-results'), defaults = $('#m-search-default'), searchT, searchCtl;
  if (q && results) {
    q.addEventListener('input', function () {
      clearTimeout(searchT);
      var term = q.value.trim();
      if (!term) { results.innerHTML = ''; if (defaults) defaults.hidden = false; return; }
      searchT = setTimeout(function () {
        if (searchCtl) searchCtl.abort();
        searchCtl = 'AbortController' in window ? new AbortController() : null;
        fetch(ROOT + 'search/suggest.json?q=' + encodeURIComponent(term) + '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last', { signal: searchCtl ? searchCtl.signal : undefined })
          .then(function (r) { return r.json(); })
          .then(function (d) {
            var ps = (d.resources && d.resources.results && d.resources.results.products) || [];
            if (defaults) defaults.hidden = true;
            if (!ps.length) { results.innerHTML = '<p style="color:var(--m-muted)">No products match “' + esc(term) + '”. Try a color or a collection name.</p>'; return; }
            results.innerHTML = '<div class="m-eyebrow" style="margin-bottom:12px">' + ps.length + (ps.length === 1 ? ' result' : ' results') + '</div><div class="m-grid">' + ps.map(function (p) {
              var img = p.featured_image && p.featured_image.url ? p.featured_image.url : p.image;
              return '<article class="m-card"><div class="m-media"><a href="' + esc(p.url) + '">' + (img ? '<img src="' + esc(imgUrl(img, 400)) + '" alt="' + esc(p.title) + '" loading="lazy">' : '<span class="m-nophoto">Photo coming soon</span>') + '</a></div><a class="m-info" href="' + esc(p.url) + '"><span class="m-info__t">' + esc(p.title) + '</span><span class="m-info__p">' + money(Math.round(parseFloat(p.price) * 100)) + '</span></a></article>';
            }).join('') + '</div><p style="margin-top:20px"><a class="m-link-caps" href="' + ROOT + 'search?q=' + encodeURIComponent(term) + '&type=product">See all results</a></p>';
          })
          .catch(function () {});
      }, 180);
    });
  }

  /* Collection sorting */
  document.addEventListener('change', function (e) {
    var s = e.target.closest('[data-m-sort]'); if (!s) return;
    var url = new URL(window.location.href); url.searchParams.set('sort_by', s.value); url.searchParams.delete('page');
    window.location.href = url.toString();
  });

  /* Product page */
  function initProduct(root) {
    if (!root || root.dataset.mReady) return; root.dataset.mReady = '1';
    var form = $('#m-product-form', root); if (!form) return;
    var variants = []; try { variants = JSON.parse($('[data-m-variants]', root).textContent); } catch (e) {}
    var idInput = $('[data-m-variant-id]', form), qtyInput = $('[data-m-qty]', form), submit = $('[data-m-submit]', form);
    var priceEl = $('[data-m-price]', root), free = $('[data-m-free]', root), sticky = $('[data-m-sticky]', root);
    var stickyPrice = $('[data-m-sticky-price]', root), stickyBtn = $('[data-m-sticky-add]', root);
    var current = variants.filter(function (v) { return String(v.id) === idInput.value; })[0] || variants[0];
    var cartTotal = 0;

    function qty() { return Math.max(1, parseInt(qtyInput.value, 10) || 1); }
    function updateFree() {
      if (!free || !M.freeCents) return;
      /* Only what is already in the cart counts; this item is a hint until it is added. */
      var left = M.freeCents - cartTotal, msg;
      if (left <= 0) msg = 'Your order gets free delivery';
      else {
        msg = cartTotal > 0 ? 'You are ' + money(left).replace(/\.00(?=\D*$)/, '') + ' away from free delivery' : 'Free delivery for orders over ' + money(M.freeCents).replace(/\.00(?=\D*$)/, '');
        if (current && current.available && cartTotal + current.price * qty() >= M.freeCents) msg += '. Adding this unlocks it';
      }
      free.querySelector('span').textContent = msg;
      free.querySelector('.m-bar i').style.width = Math.min(100, Math.round(cartTotal / M.freeCents * 100)) + '%';
    }
    function updateVariant() {
      if (!current) return;
      idInput.value = current.id;
      if (priceEl) priceEl.innerHTML = money(current.price) + (current.compare_at_price > current.price ? '<s>' + money(current.compare_at_price) + '</s>' : '');
      if (stickyPrice) stickyPrice.textContent = money(current.price * qty());
      [submit, stickyBtn].forEach(function (b) { if (!b) return; b.disabled = !current.available; b.textContent = current.available ? 'Add to cart' : 'Sold out'; });
      if (current.featured_media) {
        var slide = $('[data-media-id="' + current.featured_media.id + '"]', root), g = $('[data-m-gallery]', root);
        if (slide && g && g.scrollWidth > g.clientWidth) g.scrollTo({ left: slide.offsetLeft - g.offsetLeft, behavior: 'smooth' });
      }
      var url = new URL(window.location.href); url.searchParams.set('variant', current.id); window.history.replaceState({}, '', url.toString());
      updateFree();
    }
    $$('[data-m-option]', form).forEach(function (r) {
      r.addEventListener('change', function () {
        var chosen = $$('[data-m-option]:checked', form).map(function (i) { return i.value; });
        $$('[data-m-opt-label]', form).forEach(function (l, i) { l.textContent = chosen[i] || ''; });
        current = variants.filter(function (v) { return v.options.every(function (o, i) { return o === chosen[i]; }); })[0];
        if (!current) { [submit, stickyBtn].forEach(function (b) { if (b) { b.disabled = true; b.textContent = 'Unavailable'; } }); return; }
        updateVariant();
      });
    });
    qtyInput.addEventListener('change', function () { qtyInput.value = qty(); if (stickyPrice && current) stickyPrice.textContent = money(current.price * qty()); updateFree(); });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!current || !current.available) return;
      addItems([{ id: current.id, quantity: qty() }], submit, { title: root.querySelector('h1') ? root.querySelector('h1').textContent : '' });
    });
    document.addEventListener('m:cart', function (e) { cartTotal = e.detail.total_price; updateFree(); });
    getCart().then(function (c) { cartTotal = c.total_price; lastCart = c; setCount(c.item_count); updateFree(); }).catch(function () {});

    /* Gallery dots */
    var g = $('[data-m-gallery]', root), dots = $('[data-m-dots]', root);
    if (g && dots) g.addEventListener('scroll', function () {
      var i = Math.round(g.scrollLeft / g.clientWidth);
      $$('span', dots).forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
    }, { passive: true });

    /* Sticky add-to-cart bar on phones */
    if (sticky && submit && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (en) {
          var show = !en.isIntersecting && en.boundingClientRect.top < 0;
          sticky.classList.toggle('is-on', show);
          sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
          if (stickyBtn) stickyBtn.tabIndex = show ? 0 : -1;
          document.body.classList.toggle('m-has-sticky', show);
        });
      }).observe(submit);
    }
    updateFree();
  }
  $$('[data-m-product]').forEach(initProduct);
  document.addEventListener('shopify:section:load', function (e) { $$('[data-m-product]', e.target).forEach(initProduct); hoistMenu(); measure(); });

  /* Keep the badge right when the page comes back from the back/forward cache */
  window.addEventListener('pageshow', function (e) { if (e.persisted) refreshCart(); });
})();
